module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAYAAACEnoQPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEiSURBVHgBrZJBToNQEIZn5lHcuOAAraEnaI9AEzFxZ0+g7wTaExRvoCdATwA7E12oN/AGJdGkLutSAvMca2oLAVKafqsh/N8jzPsRaggfP4ZA7AJTok+6b1UZrJJIYSSjuw5hnKffE33aTzazVBAf5m5Z/MWAOaMDOyp/qCBDJ7sqixsnDMOnd69WVqQG0IxXK4MxC2hBQc7ZvDamreyuVtZ+90ZWW3ktwHytRw3bXmYwHbHhWxlXwYTZTM79XgD7pFCSMJo5cGhJs1CaZdz/F4SJPCfa771UyvfPn5fAeSCjA/XIL7BeHYJ/4nwqCwlgS9jkY318FOOykjbPoB0LprRPyuYptMeBrHNBRjoLO4CEA4IdQcNfFisay5Y9aIvK4h+ddWqiLa2higAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-profile.png
// module id = Pril
// module chunks = 1